export interface IClubCurrencyDefaults {
  earnUnitAmount: number;
  earnPoints: number;
  redeemPointsCost: number;
  redeemValue: number;
  topUpAmount: number;
  topUpBonus: number;
}

/**
 * Earn-unit anchor per currency: a small, round consumption amount.
 * Anchors MUST be powers of 10 so every derived value stays a round
 * number and the mental math (5% cashback, 10% top-up bonus) is obvious.
 * Everything derives from the anchor, preserving the effective 5% cashback
 * of the historical ARS defaults (1000 / 50pts / 100pts / 100).
 * Every currency in CURRENCIES MUST have an entry (unit test enforces
 * both rules).
 */
export const EARN_UNIT_BY_CURRENCY: Record<string, number> = {
  ARS: 1000,
  BRL: 10,
  UYU: 100,
  CLP: 1000,
  DOP: 100,
  EUR: 10,
  MXN: 100,
  COP: 10000,
  CRC: 1000,
  PEN: 10,
  USD: 10,
  PYG: 10000,
  VES: 100,
  BOB: 10,
};

const FALLBACK_EARN_UNIT = 10;

export function getClubCurrencyDefaults(
  currencyCode: string | null | undefined
): IClubCurrencyDefaults {
  const unit = EARN_UNIT_BY_CURRENCY[currencyCode ?? ''] ?? FALLBACK_EARN_UNIT;
  return {
    earnUnitAmount: unit,
    earnPoints: 50,
    redeemPointsCost: 100,
    redeemValue: unit / 10, // whole by construction: every anchor is a power of 10
    topUpAmount: unit * 10,
    topUpBonus: unit, // 10% gift bonus, mirrors the old 10000+1000 starter plan
  };
}
